import React from "react";
import { useNavigate } from "react-router-dom";
import { Card, Button } from "react-bootstrap";

const MembershipInactive: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div
      className="d-flex justify-content-center align-items-center min-vh-100 p-3"
      style={{ minHeight: "100vh" }}
    >
      <Card className="shadow-lg border-0" style={{ maxWidth: "480px" }}>
        <Card.Body className="p-4 text-center">
          <Card.Title className="mb-3">Membership no longer active</Card.Title>
          <Card.Text className="text-muted mb-4">
            Your membership is no longer active. To regain access, please renew
            your membership.
          </Card.Text>
          <Button
            variant="primary"
            onClick={() => navigate("/renew-membership")}
          >
            Renew / Upgrade membership
          </Button>
        </Card.Body>
      </Card>
    </div>
  );
};

export default MembershipInactive;
